module.exports = __webpack_public_path__ + "img/bg_resize_castle_roof.51fd0d2c.png";